function About() {
    return (
        <div className="section-detail about-body">
            <h1 id="about-me-title">Everything about me!</h1>
            <h3 className="about-me-detail">
                I'm an iOS Developer in Bangkok, three years into building apps people actually use — banking, retail, investment. I like the parts of the job where the hard problem isn't the UI. One day I'd like to be doing this abroad; still working out the when.
            </h3>
        </div>
    )
}

export default About